// extracted by mini-css-extract-plugin
export default {"btn":"BtnCloneToCalcGroup_btn__tATB+"};